'use client';

import Image from 'next/image';
import { useState } from 'react';

import { staticMediaStoreBaseURL } from '@/config/common';
import { FAQs } from '@/config/landingPage';

const FrequentlyAskedQuestions = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className='w-full py-10 xs:py-12 sm:py-14 px-3 xs:px-4 sm:px-6 lg:px-20'>
      <div className='max-w-5xl mx-auto'>
        <div
          className='text-center text-xl xs:text-2xl sm:text-2xl lg:text-4xl font-bold
          leading-snug mb-3 xs:mb-2 sm:mb-2 md:mb-6 text-stroke-normal tracking-wider'
        >
          Frequently Asked{' '}
          <span className='bg-brand-gradient bg-clip-text text-transparent'>
            Questions
          </span>
        </div>

        <div className='text-center text-gray-600 text-xs xs:text-sm sm:text-sm lg:text-lg mb-3 xs:mb-2 sm:mb-2'>
          Everything you need to know about partnering with Hafla
        </div>
        <div className='flex justify-center mb-8 xs:mb-8 sm:mb-6 md:mb-10 gap-2'>
          <div className='h-1 w-20 bg-brand-gradient rounded-full' />
          <div className='h-1 w-5 bg-brand-gradient rounded-full' />
        </div>
        <div className='sm:space-y-4 md:space-y-6 space-y-6'>
          {FAQs.map((faq, index) => {
            const isOpen = activeIndex === index;
            return (
              <div
                key={index}
                className={`border rounded-lg transition-all duration-300 overflow-hidden hover:border-pink-300 ${
                  isOpen ? 'border-pink-300' : 'border-pink-100'
                } bg-white/50`}
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className='w-full flex justify-between items-center text-left
                    px-3 xs:px-4 sm:px-3 md:px-6 py-3 xs:py-3 sm:py-4
                    font-semibold text-sm xs:text-sm sm:text-sm lg:text-xl
                    focus:outline-none text-neutral-900'
                >
                  <span className='flex-1 pr-2'>{faq.question}</span>
                  <div className='relative w-4 xs:w-4 sm:w-4'>
                    <Image
                      alt='Toggle Icon'
                      src={`${staticMediaStoreBaseURL}/icons/${isOpen ? 'down-angle-brand-icon' : 'down-angle'}.svg`}
                      width={0}
                      height={0}
                      className={`transition-transform duration-300 ${
                        isOpen ? 'rotate-180' : ''
                      } w-full h-auto`}
                    />
                  </div>
                </button>

                {isOpen && (
                  <div
                    className='px-3 xs:px-4 sm:px-3 md:px-6 py-3 xs:py-3 sm:py-4
                    text-gray-700 text-xs xs:text-sm sm:text-sm lg:text-base
                    border-t border-pink-100'
                  >
                    {faq.answer.split('\n').map((line, i) => (
                      <div
                        key={i}
                        className='mb-3 last:mb-0'
                      >
                        {line}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FrequentlyAskedQuestions;
